import { render, staticRenderFns } from "./select-year.vue?vue&type=template&id=d136b34c&scoped=true"
import script from "./select-year.vue?vue&type=script&lang=js"
export * from "./select-year.vue?vue&type=script&lang=js"
import style0 from "./select-year.vue?vue&type=style&index=0&id=d136b34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d136b34c",
  null
  
)

export default component.exports